import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { forwardRef, useEffect } from "react";
import { SEARCH_STATIC_HEADER_Z_INDEX } from "~/constants/WorkspaceSpacing";
import { useSearchHeaderHeightContext } from "~/providers/SearchHeaderHeightProvider";
export const TopBar = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { children, className, style } = param;
    const { setSearchHeaderHeight } = useSearchHeaderHeightContext();
    useEffect(()=>{
        if (forwardedRef && "current" in forwardedRef && forwardedRef.current) {
            setSearchHeaderHeight(forwardedRef.current.offsetHeight);
        }
    }, [
        forwardedRef,
        setSearchHeaderHeight
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: tailwindMerge("sticky inset-x-0 top-0 flex shrink-0 items-start justify-between bg-grey-3 px-3 py-1 text-12 font-medium text-grey-11 md:bg-grey-1 md:px-12 md:py-4", className),
        style: {
            zIndex: SEARCH_STATIC_HEADER_Z_INDEX,
            ...style
        },
        ref: forwardedRef,
        children: children
    });
});
TopBar.displayName = "TopBar";
